import { appSettingsInternalUserGroupsInternalUserGroupIdV2TestUsers } from "../appSettingsInternalUserGroupsInternalUserGroupIdV2TestUsers";
import type { AllRouteEndpoints } from "../routeTypes";
export const appSettingsInternalUserGroupsBulkAddUsersToGroupV2AppGroupIdCacheKeys: AllRouteEndpoints[] = [
  "/internal_user_groups/test_user_app_data",
  "/internal_user_groups/test_user_names",
  appSettingsInternalUserGroupsInternalUserGroupIdV2TestUsers,
];
